module.exports = __webpack_public_path__ + "img/finance-application-display-hyundai.97c3bd3e.png";